module.exports = __webpack_public_path__ + "static/media/abb-ib.3ef725b8.png";